<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('customer_credit_cards')"
                @filter-div-status="datatable.filterStatus = $event">
        </Header>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('customer_credit_cards')"
                      @filter-div-status="datatable.filterStatus = $event">
        </HeaderMobile>
      </template>
      <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
        <b-row>
          <b-col sm="6">
            <b-form-group :label="$t('student_number')">
              <b-form-input v-model="datatable.queryParams.filter.student_number"/>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('name')">
              <b-form-input v-model="datatable.queryParams.filter.name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('surname')">
              <b-form-input v-model="datatable.queryParams.filter.surname">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </datatable-filter>
      <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                 :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                 @on-page-change="onPageChange" @on-sort-change="onSortChange"
                 @on-per-page-change="onPerPageChange"
                 v-show="datatable.showTable">
      </datatable>
      <CommonModal ref="showModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()"
                   v-if="checkPermission('customercreditcard_show')">
        <template v-slot:CommonModalTitle>
          {{ $t('show').toUpper() }}
        </template>
        <template v-slot:CommonModalContent>
          <show-form :formId="formId"
                     v-if="formProcess=='show'"
          />
        </template>
      </CommonModal>
    </app-layout>
  </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
//Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
//Other
import qs from 'qs'
//Service
import CustomerCreditCardService from "@/services/CustomerCreditCardService";
//Page
import ShowForm from "./ShowForm"

export default {
  components: {
    AppLayout,
    Header,
    HeaderMobile,

    DatatableFilter,
    Datatable,
    CommonModal,

    ShowForm
  },
  metaInfo() {
    return {
      title: this.$t('customer_credit_cards')
    }
  },
  data() {
    return {
      formId: 0,
      form: {},
      formProcess: null,
      datatable: {
        isLoading: false,
        columns: [
          {
            label: '',
            field: 'buttons',
            html: true,
            sortable: false,
            tdClass: 'p-0 text-center w-40 align-middle',
            buttons: [
              {
                text: this.$t('show'),
                class: 'ri-search-eye-line',
                permission: 'customercreditcard_show',
                callback: (row) => {
                  this.showForm(row.id);
                },
              },
              {
                text: this.$t('delete'),
                class: 'ri-delete-bin-2-line',
                permission: 'customercreditcard_delete',
                callback: (row) => {
                  this.formDelete(row.id);
                }
              },
            ]
          },
          {
            label: this.$t('name'),
            field: 'customer_name',
            sortable: true,
          },
          {
            label: this.$t('surname'),
            field: 'customer_surname',
            sortable: true,
          },
          {
            label: this.$t('email'),
            field: 'email',
            sortable: true,
          },
          {
            label: this.$t('card_number'),
            field: 'card_number',
            sortable: true,
          },

        ],
        rows: [],
        total: 0,
        filterStatus: true,
        showTable: false,
        queryParams: {
          filter: {},
          sort: 'id',
          page: 1,
          limit: 20
        }
      }
    }
  },
  methods: {
    filter() {
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    filterClear() {
      this.datatable.queryParams.filter = {};
      this.getRows();
    },
    onPageChange(params) {
      this.datatable.queryParams.page = params.currentPage;
      this.getRows();
    },
    onPerPageChange(params) {
      this.datatable.queryParams.limit = params.currentPerPage;
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    onSortChange(params) {
      const sortType = params[0].type == 'desc' ? '-' : '';
      this.datatable.queryParams.sort = sortType + params[0].field
      this.getRows();
    },
    getRows() {
      this.datatable.showTable = true;
      this.datatable.isLoading = true;

      const config = {
        params: {
          ...this.datatable.queryParams
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false})
      };

      return CustomerCreditCardService.getAll(config)
          .then((response) => {
            this.datatable.rows = response.data.data
            this.datatable.total = response.data.pagination.total
          })
          .finally(() => {
            this.datatable.isLoading = false;
          });
    },
    formDelete(id) {
      this.$swal
          .fire({
            text: this.$t('are_you_sure_to_delete'),
            showCancelButton: true,
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no'),
          })
          .then((result) => {
            if (result.isConfirmed) {
              CustomerCreditCardService.del(id)
                  .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.getRows();
                    this.formClear();
                  })
                  .catch(error => {
                    this.$toast.error(this.$t('api.' + error.data.message));
                  });
            }
          })
    },
    formClear() {
      this.formId = null
      this.formProcess = null
    },
    showForm(id) {
      this.formId = id
      this.formProcess = 'show'
      this.$refs.showModal.$refs.commonModal.show()
    },
  }
};
</script>

